import { DEFAULT_WIDGET_SPACING } from '../spacing';
import type { FrontendWidget } from '../types';
import { RoomsGalleryComponent } from './RoomsGalleryComponent';
import { RoomsGalleryComponentB } from './RoomsGalleryComponentB';
import { RoomsGalleryComponentC } from './RoomsGalleryComponentC';
import type { RoomsGalleryConfig, RoomsGalleryResolved } from './types';

export const roomsGalleryWidget: FrontendWidget<
  RoomsGalleryConfig,
  RoomsGalleryResolved
> = {
  componentType: 'widgets.rooms-gallery',
  displayName: 'Rooms Gallery',
  ComponentA: RoomsGalleryComponent,
  ComponentB: RoomsGalleryComponentB,
  ComponentC: RoomsGalleryComponentC,
  // Inline: the rooms come from `entities.location`, which the render context
  // already carries — no backend resolver of its own.
  resolveSync: (config) => ({
    ...config,
    alignment: config.alignment ?? 'center',
    columns: config.columns ?? '3',
    // Mirrors the Strapi default, for entries written before the field existed.
    spacing: config.spacing ?? DEFAULT_WIDGET_SPACING,
  }),
};
